"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = editorReducer;
exports.defaultState = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var actions = _interopRequireWildcard(require("./editorActions"));

var utils = _interopRequireWildcard(require("./utils"));

var defaultSelection = {
  activeX: 0,
  activeY: 0,
  left: 0,
  right: 1,
  top: 0,
  bottom: 1
};

var defaultState = function defaultState(columns, rows) {
  return {
    columns: columns,
    editing: {
      value: null
    },
    rows: rows,
    selection: rows.length > 0 ? defaultSelection : null
  };
};

exports.defaultState = defaultState;

function cancelActiveCell(state) {
  var newEditing = utils.cancelEdit();
  return (0, _objectSpread2.default)({}, state, {
    editing: newEditing
  });
}

function editActiveCell(state, action) {
  var value = action.payload.value;
  var editing = utils.changeEdit(value);
  return (0, _objectSpread2.default)({}, state, {
    editing: editing
  });
}

function submitActiveCell(state) {
  var columns = state.columns,
      editing = state.editing,
      rows = state.rows,
      selection = state.selection;
  var newEditing = utils.cancelEdit();
  var newRows = utils.submitEdit(columns, rows, selection, editing);
  return (0, _objectSpread2.default)({}, state, {
    editing: newEditing,
    rows: newRows
  });
}

function insertColumns(state, action) {
  var _action$payload = action.payload,
      startIndex = _action$payload.startIndex,
      addColumns = _action$payload.columns;
  var columns = state.columns,
      editing = state.editing,
      rows = state.rows,
      selection = state.selection;
  var newEditing = utils.cancelEdit();
  var submitRows = utils.submitEdit(columns, rows, selection, editing);
  var newColumns = utils.insertColumns(columns, startIndex, addColumns);
  var newRows = utils.addColumnsToRows(newColumns, submitRows);
  var newSelection = utils.isWidthEmpty(selection) ? utils.refreshSelection(null, newColumns, newRows) : utils.pointExpandSelection(selection, {
    x: startIndex
  }, {
    width: addColumns.length
  });
  return (0, _objectSpread2.default)({}, state, {
    columns: newColumns,
    editing: newEditing,
    rows: newRows,
    selection: newSelection
  });
}

function removeColumns(state, action) {
  var _action$payload2 = action.payload,
      startIndex = _action$payload2.startIndex,
      endIndex = _action$payload2.endIndex;
  var columns = state.columns,
      editing = state.editing,
      rows = state.rows,
      selection = state.selection;
  var newEditing = utils.cancelEdit();
  var submittedRows = utils.submitEdit(columns, rows, selection, editing);
  var newColumns = utils.removeColumns(columns, Math.min(startIndex, endIndex), Math.abs(endIndex - startIndex));
  var newRows = utils.removeColumnsFromRows(newColumns, submittedRows);
  var region = {
    left: 0,
    right: newColumns.length,
    top: 0,
    bottom: rows.length
  };
  var newSelection = utils.shrinkSelectionToFitRegion(selection, region);
  return (0, _objectSpread2.default)({}, state, {
    columns: newColumns,
    editing: newEditing,
    rows: newRows,
    selection: newSelection
  });
}

function loadDatasheet(state, action) {
  var _action$payload3 = action.payload,
      columns = _action$payload3.columns,
      rows = _action$payload3.rows;
  var newEditing = utils.cancelEdit();
  var newSelection = utils.refreshSelection(null, columns, rows);
  return (0, _objectSpread2.default)({}, state, {
    columns: columns,
    editing: newEditing,
    rows: rows,
    selection: newSelection
  });
}

function insertSnippet(state, action) {
  var snippet = action.payload.snippet;
  var columns = state.columns,
      rows = state.rows,
      selection = state.selection;
  var clippedSnippet = utils.isUnitSized(selection) ? snippet : utils.clipSnippet(selection, snippet);
  var newEditing = utils.cancelEdit();
  var newRows = utils.insertSnippet(rows, columns, selection, clippedSnippet);
  var left = selection.left,
      top = selection.top;
  var newSelection = {
    left: left,
    right: left + Math.max(1, utils.getSnippetWidth(clippedSnippet)),
    top: top,
    bottom: top + Math.max(1, utils.getSnippetHeight(clippedSnippet)),
    activeX: left,
    activeY: top
  };
  var shrunkSelection = utils.jumpSelection(newSelection, columns, rows);
  return (0, _objectSpread2.default)({}, state, {
    editing: newEditing,
    rows: newRows,
    selection: shrunkSelection
  });
}

function insertRows(state, action) {
  var _action$payload4 = action.payload,
      startIndex = _action$payload4.startIndex,
      addRows = _action$payload4.rows;
  var columns = state.columns,
      editing = state.editing,
      rows = state.rows,
      selection = state.selection;
  var newEditing = utils.cancelEdit();
  var submitRows = utils.submitEdit(columns, rows, selection, editing);
  var newRows = utils.insertRows(submitRows, startIndex, addRows);
  var newSelection = utils.isHeightEmpty(selection) ? utils.refreshSelection(null, columns, newRows) : utils.pointExpandSelection(selection, {
    y: startIndex
  }, {
    height: addRows.length
  });
  return (0, _objectSpread2.default)({}, state, {
    editing: newEditing,
    rows: newRows,
    selection: newSelection
  });
}

function removeRows(state, action) {
  var _action$payload5 = action.payload,
      startIndex = _action$payload5.startIndex,
      endIndex = _action$payload5.endIndex;
  var columns = state.columns,
      editing = state.editing,
      rows = state.rows,
      selection = state.selection;
  var newEditing = utils.cancelEdit();
  var submitRows = utils.submitEdit(columns, rows, selection, editing);
  var newRows = utils.removeRows(submitRows, Math.min(startIndex, endIndex), Math.abs(endIndex - startIndex));
  var region = {
    left: 0,
    right: columns.length,
    top: 0,
    bottom: newRows.length
  };
  var newSelection = utils.shrinkSelectionToFitRegion(selection, region);
  return (0, _objectSpread2.default)({}, state, {
    editing: newEditing,
    rows: newRows,
    selection: newSelection
  });
}

function clearSelection(state, action) {
  var selection = action.payload.selection;
  var columns = state.columns,
      rows = state.rows;
  var newEditing = utils.cancelEdit();
  var newRows = utils.clearSelection(rows, columns, selection);
  return (0, _objectSpread2.default)({}, state, {
    editing: newEditing,
    rows: newRows
  });
}

function jumpSelection(state, action) {
  var targetSelection = action.payload.selection;
  var columns = state.columns,
      editing = state.editing,
      rows = state.rows,
      selection = state.selection;
  var newEditing = utils.cancelEdit();
  var newRows = utils.submitEdit(columns, rows, selection, editing);
  var newSelection = utils.jumpSelection(targetSelection, columns, newRows);
  return (0, _objectSpread2.default)({}, state, {
    editing: newEditing,
    rows: newRows,
    selection: newSelection
  });
}

function moveSelection(state, action) {
  var _action$payload6 = action.payload,
      x = _action$payload6.x,
      y = _action$payload6.y,
      activeOnly = _action$payload6.activeOnly;
  var columns = state.columns,
      editing = state.editing,
      rows = state.rows,
      selection = state.selection;
  var newEditing = utils.cancelEdit();
  var newRows = utils.submitEdit(columns, rows, selection, editing);
  var newSelection = activeOnly && !utils.isUnitSized(selection) ? utils.moveSelectionInside(selection, x, y) : utils.moveSelection(selection, columns, newRows, x, y);
  return (0, _objectSpread2.default)({}, state, {
    editing: newEditing,
    rows: newRows,
    selection: newSelection
  });
}

function resizeSelection(state, action) {
  var _action$payload7 = action.payload,
      x = _action$payload7.x,
      y = _action$payload7.y;
  var columns = state.columns,
      editing = state.editing,
      rows = state.rows,
      selection = state.selection;
  var newEditing = utils.cancelEdit();
  var newRows = utils.submitEdit(columns, rows, selection, editing);
  var newSelection = utils.resizeSelection(selection, columns, newRows, x, y);
  return (0, _objectSpread2.default)({}, state, {
    editing: newEditing,
    rows: newRows,
    selection: newSelection
  });
}

function editorReducer(state, action) {
  switch (action.type) {
    case actions.ACTIVE_CELL_CANCEL:
      return cancelActiveCell(state, action);

    case actions.ACTIVE_CELL_EDIT:
      return editActiveCell(state, action);

    case actions.ACTIVE_CELL_SUBMIT:
      return submitActiveCell(state, action);

    case actions.COLUMNS_INSERT:
      return insertColumns(state, action);

    case actions.COLUMNS_REMOVE:
      return removeColumns(state, action);

    case actions.DATASHEET_LOAD:
      return loadDatasheet(state, action);

    case actions.ROWS_INSERT:
      return insertRows(state, action);

    case actions.ROWS_REMOVE:
      return removeRows(state, action);

    case actions.SELECTION_CLEAR:
      return clearSelection(state, action);

    case actions.SELECTION_JUMP:
      return jumpSelection(state, action);

    case actions.SELECTION_MOVE:
      return moveSelection(state, action);

    case actions.SELECTION_RESIZE:
      return resizeSelection(state, action);

    case actions.SNIPPET_INSERT:
      return insertSnippet(state, action);

    default:
      return state;
  }
}